import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from '../../Modal/Modal';
import StepByStep from '../../StepByStep';
import CancelTriggerOrder from './CancelTriggerOrder';
import Status from '../Status';
import themeColors from '../../../assets/styles/themeColors';

const steps = [CancelTriggerOrder, Status];

const CancelTriggerOrderModal = ({
  isOpen,
  handleClose,
  cancelTransactionData,
  handleRefreshTransactions,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      size="sm"
      title={t('portfolio.pendingTransactions.cancelTriggerOrder.title')}
      titleFontSize="18px"
      centerTitle
      close={handleClose}
      isOpen={isOpen}
      closeIconVisible
      closeIconSize="12.5px"
      closeIconColor={themeColors.colorTextPrimary}
      hideHeaderShadow
    >
      <StepByStep saveStepDisabled>
        {({ goStepForward, goStepBack }) =>
          steps.map((step) =>
            React.createElement(step, {
              handleBack: goStepBack,
              handleNext: goStepForward,
              handleClose,
              setError,
              hasError: !!error,
              text:
                error ||
                t('portfolio.pendingTransactions.cancelTriggerOrder.success'),
              backButtonText: t('common.ok'),
              onButtonClick: handleClose,
              cancelTransactionData,
              handleRefreshTransactions,
            }),
          )
        }
      </StepByStep>
    </Modal>
  );
};

CancelTriggerOrderModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  cancelTransactionData: PropTypes.shape({
    paymentUid: PropTypes.string,
    accountUid: PropTypes.string,
    amount: PropTypes.number,
    productName: PropTypes.string,
    requestDate: PropTypes.string,
    quantity: PropTypes.number,
  }),
  handleRefreshTransactions: PropTypes.func,
};

export default CancelTriggerOrderModal;
